import { Button, Tooltip } from 'antd';

interface IProps {
    onClick: () => void;
    title?: string;
}

function CircleAddBtn(props: IProps) {
    const { title, onClick } = props;
    return (
        <Tooltip placement="bottom" title={title}>
            <Button shape="circle" size="small" color="default" variant="filled" onClick={onClick}>
                +
            </Button>
        </Tooltip>

    );
}

export default CircleAddBtn;